import { Button } from 'foundations-components/transitional/components/Button';
import { usePortalData } from '../data/usePortalData';
import { useFormData } from '../data/useFormData';
import { useNavigationContext } from '../hooks/useNavigationContext';
import { usageTracker } from '../utils/usageTracker';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateTicketButton() {
  const {
    data
  } = usePortalData();
  const {
    formMenuText
  } = (data === null || data === void 0 ? void 0 : data.settings) || {};
  const {
    data: formData
  } = useFormData();
  const {
    toNewTicket
  } = useNavigationContext();
  const isMobile = useIsMobile();
  if (!(formData !== null && formData !== void 0 && formData.formGuid)) return null;
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "create-ticket-button",
    use: "primary",
    size: isMobile ? 'small' : undefined,
    onClick: () => {
      usageTracker.track('Customer Portal App', 'Tickets Manipulated', {
        action: 'create-ticket-clicked',
        screen: 'ticket-listings'
      });
      toNewTicket();
    },
    children: formMenuText
  });
}